import React, { Component } from 'react';
import { HeaderSub2 } from '../Common/HeaderSub2'
import { HomeBestMore } from './HomeBestMore'
import { Big3Common } from '../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:광고 리스트 라우팅 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.HomeBestMore,
        };
        this.AdIndex = Big3Common.Util.GetParams("adindex");
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    //호출할 컴포넌트 이름
    CompName = {
        "HomeBestMore": "HomeBestMore"
    }
    renderPick() {
        let HeaderTitle = "";
        let adindex = this.AdIndex;
        if (adindex !== null) {

            if (adindex === Big3Common.AdIndex.NewGoods) {
                HeaderTitle = "오늘의 신상";
            }
            else if (adindex === Big3Common.AdIndex.BestView) {
                HeaderTitle = "가장 많이 본 상품";
            }
            else if (adindex === Big3Common.AdIndex.WeekBest) {
                HeaderTitle = "한주간 베스트상품";
            }
            else if (adindex === Big3Common.AdIndex.SeasonPlan) {
                HeaderTitle = "시즌 상품기획전";
            }
            else if (adindex === Big3Common.AdIndex.SpecialPrice) {
                HeaderTitle = "놓치면 후회할 특가상품";
            }
        }
        if (this.state.RenderName === this.CompName.HomeBestMore) {
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle={HeaderTitle }
                        HistoryBack={true}
                    />
                    <HomeBestMore
                        AdIndex={this.AdIndex}
                    />
                </div>
            );
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
